import React from "react";
import axios from "axios";
import CareemLogo from "../../images/transparent_logo.png";
import LoadingSpinner from "../LoadingSpinner";
import VerificationLinkExpired from "./VerificationLinkExpired";
import VerificationTokenAlreadyUsed from "./VerificationTokenAlreadyUsed";
import EmailVerified from "./EmailVerified";
import UnlinkEmail from "./UnlinkEmail";
import i18n from "i18next";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";

const PAGE_NAME = ANALYTIKA_EVENTS.PAGE.EMAIL_VERIFICATION;

export default class EmailVerification extends React.Component {
  constructor(props) {
    super(props);
    const search = props.location.search;
    const params = new URLSearchParams(search);
    this.state = {
      loading: true,
      linkVerified: false,
      linkExpired: false,
      unlinkEmail: false,
      linkAlreadyUsed: false,
      error: false,
      unlink: props.unlink,
      verify: props.verify,
      language: params.get("lang") || "en",
    };
    i18n.changeLanguage(this.state.language);
  }

  componentDidMount() {
    document.title = "Email verification | Careem";
    const flowType = this.state.unlink ? "unlink" : "verify";
    eventAnalytics.publishViewPage(PAGE_NAME, { flow_type: flowType });
    if (this.state.unlink) {
      this.unlink();
    } else if (this.state.verify) {
      this.verify();
    } else {
      this.setState({ linkExpired: true, loading: false });
      eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
        page_name: PAGE_NAME,
        result_state: "linkExpired",
      });
    }
  }

  runVerificationRequest(requestType, makeRequest, alreadyUsedFalseState) {
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBREQUEST, {
      request_type: requestType,
    });
    return makeRequest()
      .then((res) => {
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
          request_type: requestType,
          request_status: "success",
        });
        if (200 === res.status) {
          this.setState({ linkAlreadyUsed: true, loading: false });
        } else {
          this.setState({ ...alreadyUsedFalseState, loading: false });
        }
      })
      .catch((failure) => {
        const errorMessage =
          failure.response?.data?.description ||
          failure.response?.data?.message ||
          failure.response?.data;
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE, {
          request_type: requestType,
          request_status: "failed",
          error_code_string: failure.response?.status?.toString(),
          error_description: errorMessage,
        });
        eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
          page_name: PAGE_NAME,
          result_state: "linkExpired",
          error_message: errorMessage,
        });
        this.setState({ linkExpired: true, loading: false });
      });
  }

  unlink() {
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/users/email/verification/${this.props.match.params.verificationId}`;
    this.runVerificationRequest("email_unlink", () => axios.delete(endpoint), {
      unlinkAccount: true,
    });
  }

  verify() {
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/users/email/verification/${this.props.match.params.verificationId}`;
    this.runVerificationRequest("email_verify", () => axios.put(endpoint), {
      linkVerified: true,
    });
  }

  render() {
    let component;
    const verificationId = this.props.match?.params?.verificationId;
    if (this.state.loading) {
      component = <LoadingSpinner />;
    } else if (this.state.linkVerified) {
      component = <EmailVerified verificationId={verificationId} />;
    } else if (this.state.linkExpired) {
      component = <VerificationLinkExpired verificationId={verificationId} />;
    } else if (this.state.linkAlreadyUsed) {
      component = (
        <VerificationTokenAlreadyUsed verificationId={verificationId} />
      );
    } else if (this.state.unlinkAccount) {
      component = <UnlinkEmail verificationId={verificationId} />;
    }
    return <EmailVerificationContainer children={component} />;
  }
}

export const EmailVerificationContainer = (props) => {
  return (
    <div className="email_container">
      <div className="careem-logo-container">
        <img src={CareemLogo} className="careem-logo" alt="Careem Logo" />
      </div>
      {props.children}
    </div>
  );
};
